<template>
  <div>
    <div class="xq_top">
      <img class="img" @click="xqesc" src="../../static/images/esc.png" />
      <p @click="xqesc">{{pickda[pickxb].fh}}</p>
      <span>{{pickda[pickxb].ddxq}}</span>
    </div>
    <div class="qwe_main">
      <ul>
        <li class="on">{{pickda[pickxb].ctmc}}</li>
        <li>{{list.Shop}}</li>
        <li class="on">{{pickda[pickxb].lxdh}}</li>
        <li>{{list.Telephone}}</li>
        <li class="on">{{pickda[pickxb].lxdz}}</li>
        <li>{{list.Address}}</li>
        <li class="on">{{pickda[pickxb].tssj}}</li>
        <li>{{list.TakeOutSatrtTime}}~{{list.TakeOutEndTime}}</li>
        <li class="on">{{pickda[pickxb].wmsj}}</li>
        <li>{{list.InDineSatrtTime}}~{{list.InDineEndTime}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        ShopID: 0,
        DeskID: 0,
        Context: "",
        pickxb: 0,
        list:{},
        pickda: [
          {fh: "返回",ddxq: "餐厅信息",ctmc:"餐厅名称",lxdh:"联系电话",lxdz:"联系地址",tssj:"营业时间",wmsj:"外卖时间"},
          {fh: "返回",ddxq: "餐廳信息",ctmc:"餐廳名稱",lxdh:"聯繫電話",lxdz:"餐廳地址",tssj:"營業時間",wmsj:"外賣時間"},
          {fh: "Back",ddxq: "Information",ctmc:"Restaurant Name",lxdh:"Phone Number",lxdz:"Address",tssj:"Hours of operation",wmsj:"Online Order"},
          {fh: "إرجاع",ddxq: "معلومات المطعم",ctmc:"معلومات المطعم...",lxdh:"رقم الاتصال",lxdz:"عنوان الإتصال",tssj:"الوقت الكريم",wmsj:"وقت الوجبات الجاهزة"},
          {fh: "ដកថយ",ddxq: "ព័ត៌មានភោជនីយដ្ឋាន",ctmc:"ឈ្មោះភោជនីយដ្ឋាន",lxdh:"លេខ​ទំនាក់​ទំនង",lxdz:"អាស័យ​ដ្ឋាន​ទំនាក់ទំនង",tssj:"ពេលទទួលទានអាហារ",wmsj:"ពេលវេលាយក"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "Terug",ddxq: "Restaurant informatie",ctmc:"Naam restaurant",lxdh:"Contact nummer",lxdz:"Contact adres",tssj:"Dinertijd",wmsj:"Afhaaltijd"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "Indietro",ddxq: "Chi siamo",ctmc:"Nome del negozio",lxdh:"Numero cellulare",lxdz:"Indirizzo",tssj:"Orario apertura tavolo",wmsj:"Takeout time"},
          {fh: "戻り",ddxq: "お店情報",ctmc:"お店の名前",lxdh:"電話番号",lxdz:"住所",tssj:"営業時間",wmsj:"デリバリー営業時間"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "Zurück",ddxq: "Restaurantinformationen",ctmc:"Restaurantname",lxdh:"Telefonnummer",lxdz:"Kontaktadresse / Anschrift",tssj:"Verzehrzeit vor Ort",wmsj:"Lieferzeit / Abholzeit"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "return",ddxq: "information",ctmc:"Restaurant name",lxdh:"contact number",lxdz:"Contact address",tssj:"Dining time",wmsj:"Takeout time"},
          {fh: "kembali",ddxq: "informasi restoran",ctmc:"nama restoran",lxdh:"nomor kontak",lxdz:"alamat kontak",tssj:"waktu makan di tempat",wmsj:"waktu bawa pulang" },
          {fh: "กลับ",ddxq: "ข้อมูลร้านอาหาร",ctmc:"ชื่อร้านอาหาร",lxdh:"เบอร์ติดต่อ",lxdz:"ที่อยู่ติดต่อ",tssj:"เวลารับประทานอาหาร",wmsj:"เวลานำกลับบ้าน"},
          {fh: "απόδοση",ddxq: "Πληροφορίες εστιατορίου",ctmc:"Όνομα εστιατορίου",lxdh:"Αριθμός επικοινωνίας",lxdz:"Διεύθυνση επικοινωνίας",tssj:"Ώρα για φαγητό",wmsj:"Ώρα σε πακέτο"},
          {fh: "Nazaj",ddxq: "Informacije o restavraciji",ctmc:"Ime restavracije",lxdh:"GSM",lxdz:"Naslov",tssj:"Čas dine-in",wmsj:"Čas prevzema"},
          {fh: "Back",ddxq: "Restaurant Info",ctmc:"Restaurant Name",lxdh:"Cell Phone",lxdz:"Address",tssj:"Dine-In Time",wmsj:"Takeaway Time"},
		  {fh: "ပြန်",ddxq: "စားသောက်ဆိုင်အချက်အလက်",ctmc:"စားသောက်ဆိုင်အမည်",lxdh:"ဆက်သွယ်ဖုန်း",lxdz:"ဆက်သွယ်လိပ်စာ",tssj:"လုပ်ငန်းအချိန်",wmsj:"ရောင်းချချိန်"},
		  {fh: "Geri Dön",ddxq: "Restoran Bilgisi",ctmc:"Restoran Adı",lxdh:"İletişim Tel.",lxdz:"İletişim Adresi",tssj:"Açık Pazza Saati",wmsj:"Gönderme Saati"},
		  {fh:"qayıtmaq",ddxq:"Restoran Məlumatı",ctmc:"Restoran Adı",lxdh:"Əlaqə nömrəsi",lxdz:"Ünvan",tssj:"İş saatları",wmsj:"Çatdırılma vaxtı"},
		  {fh:"буцах",ddxq:"Рестораны мэдээлэл",ctmc:"Рестораны нэр",lxdh:"Холбоо барих дугаар",lxdz:"Холбоо барих хаяг",tssj:"Хооллох цаг",wmsj:"Хүргэлтийн хугацаа"},
        ]
      }
    },
    mounted() {
      this.ShopID = this.$route.query.ShopID;
      this.DeskID = this.$route.query.id;
      if (localStorage.getItem(this.$route.query.ShopID+'pickxb'))
        this.pickxb = localStorage.getItem(this.$route.query.ShopID+'pickxb');
      if (localStorage.getItem(this.$route.query.ShopID+'pickxb') != null) //判断语音下标
        this.pickxb = localStorage.getItem(this.$route.query.ShopID+'pickxb')
      console.log(localStorage.getItem(this.$route.query.ShopID+'pickxb'))
      console.log(this.pickxb)
      this.axios.post(this.$lujin + "/api/Default/Parameter?ShopID=" + this.$route.query.ShopID)
        .then((res) => {
          console.log(res)
          console.log(res.data.data[0])
          var sz=(res.data.data[0])
          var pq1="",pq2="",pq3="",pq4=""
          for(var i in sz.InDineSatrtTime){
            if(i>10){
              pq1+=sz.InDineEndTime[i]
              pq2+=sz.InDineSatrtTime[i]
              pq3+=sz.TakeOutEndTime[i]
              pq4+=sz.TakeOutSatrtTime[i]
            }
          }
          sz.InDineEndTime=pq1
          sz.InDineSatrtTime=pq2
          sz.TakeOutEndTime=pq3
          sz.TakeOutSatrtTime=pq4
          this.list=sz
        })
    },
    methods: {
      xqesc() {
        this.$router.go(-1);
      },
    }
  }
</script>

<style>
  .qwe_main{font-size:.28rem;padding-top:1.2rem;}
  .qwe_main ul{width:96%;margin:0 auto;}
  .qwe_main ul li{height:1.2rem;word-wrap:break-word;display: flex;align-items: center;justify-content: center;flex-direction: column;}
  .qwe_main ul li.on{font-size:.3rem;font-weight:bold;}
</style>



// WEBPACK FOOTER //
// src/components/qwe.vue